import { isInView } from './utils';

const timeline = {
  timeline: document.querySelectorAll(
    '.jsSingleTimeline',
  ) as NodeListOf<HTMLElement>,

  init() {
    this.setViewport();
  },

  setViewport(): void {
    const timelineSection = document.getElementById('timeline') as HTMLElement;
    if (!timelineSection) return;

    window.addEventListener('scroll', () => {
      const sectionRect = timelineSection.getBoundingClientRect();

      if (sectionRect.top >= window.innerHeight) {
        this.timeline.forEach((item: HTMLElement) => {
          item.classList.remove('activeClass');
        });
        return;
      }

      this.timeline.forEach((item: HTMLElement) => {
        if (!item.classList.contains('activeClass') && isInView(item)) {
          item.classList.add('activeClass');
        }
      });
    });
  },
};

export default timeline;
